import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import Seo from '../components/Seo';
import { DIVISIONS } from '../mock';
import { ArrowRight, Calendar, CheckCircle2 } from 'lucide-react';

export default function Divisions() {
  return (
    <div>
      <Seo title="Our Divisions | Fixed Group — FBRSSB, FLS & FCFS" description="Three specialised companies, one cold chain vision — Fixed Borneo Reefer Services, Fixed Logistic Sdn.Bhd. and Fixed Chiller & Freezer Services." />
      <PageHeader title="Our Divisions" crumbs={[{ label: 'Divisions' }]} />
      <section className="py-16">
        <div className="fx-container">
          <div className="max-w-3xl">
            <span className="text-xs uppercase tracking-widest text-emerald-600 font-semibold">The Fixed Group of Companies</span>
            <h2 className="section-title text-3xl md:text-4xl font-extrabold mt-2">Three specialised entities. One cold chain vision.</h2>
            <p className="mt-6 text-slate-600 leading-relaxed">Each Fixed Group company focuses on a critical piece of the cold chain — from reefer container repair and cold room construction to nationwide temperature-controlled trucking and terminal reefer monitoring.</p>
          </div>

          <div className="mt-12 space-y-10">
            {DIVISIONS.map((d, idx) => (
              <div key={d.slug} className={`grid lg:grid-cols-2 gap-8 items-center ${idx % 2 === 1 ? 'lg:[&>div:first-child]:order-2' : ''}`}>
                <div className="rounded-2xl overflow-hidden shadow-lg">
                  <img src={d.image} alt={d.name} className="w-full h-80 object-cover" />
                </div>
                <div>
                  <div className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-emerald-600 font-semibold"><Calendar size={14} /> Est. {d.established} • {d.short}</div>
                  <h3 className="mt-3 text-2xl md:text-3xl font-extrabold text-slate-900">{d.name}</h3>
                  <p className="mt-4 text-slate-600 leading-relaxed">{d.summary}</p>
                  <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2">
                    {d.services.slice(0,6).map((s, i) => (
                      <li key={i} className="flex items-start gap-2 text-sm text-slate-700"><CheckCircle2 size={16} className="text-emerald-500 mt-0.5 flex-shrink-0" />{s}</li>
                    ))}
                  </ul>
                  <Link to={`/divisions/${d.slug}`} className="mt-6 inline-flex items-center gap-2 text-emerald-700 font-semibold hover:text-emerald-800">Explore {d.short} <ArrowRight size={16} /></Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
